import { useTranslation } from "react-i18next";

import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import { useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";

interface ConfirmEmptyImeiDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmEmptyImeiDialog = ({
  isOpen,
  onClose,
  onSubmit
}: ConfirmEmptyImeiDialogProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  return (
    <Dialog
      title={t("Dialog##confirm empty imei##title")}
      description={t("Dialog##confirm empty imei##description")}
      extendToMaxWidth={toMd}
      isActionsSeparator
      open={isOpen}
      close={onClose}
      submit={onSubmit}
      width={toMd ? undefined : DialogWidth.MinWidth}
      actions={
        <DialogActions
          onClose={onClose}
          isLoading={false}
          isreadyToConfirm
          confirmationButtonText={t("Button##continue")}
          confirmationButtonTestId="confirm-empty-imei-button"
          cancelButtonText={t("Button##back")}
          cancelButtonTestId="close-confirm-empty-imei"
        />
      }
    />
  );
};

export default ConfirmEmptyImeiDialog;
